import type { FmpExchangeMarketHour } from '@/queries';

export interface FinancialMarketHub {
    exchangeCodes: readonly string[];
    primaryExchange: string;
}

export const FINANCIAL_MARKET_HUBS_BY_TIMEZONE: Readonly<Record<string, FinancialMarketHub>> = {
    'America/New_York': {
        exchangeCodes: ['NYSE', 'NASDAQ', 'AMEX'],
        primaryExchange: 'NYSE',
    },
    'Europe/Dublin': {
        exchangeCodes: ['DUB'],
        primaryExchange: 'DUB',
    },
    'Europe/London': {
        exchangeCodes: ['LSE', 'AQS', 'IOB'],
        primaryExchange: 'LSE',
    },
    'Europe/Paris': {
        exchangeCodes: ['PAR', 'EURONEXT'],
        primaryExchange: 'PAR',
    },
    'Europe/Zurich': {
        exchangeCodes: ['SIX', 'EBS'],
        primaryExchange: 'SIX',
    },
    'Europe/Berlin': {
        exchangeCodes: ['XETRA', 'FSX'],
        primaryExchange: 'XETRA',
    },
    'Asia/Dubai': {
        exchangeCodes: ['DFM'],
        primaryExchange: 'DFM',
    },
    'Asia/Hong_Kong': {
        exchangeCodes: ['HKSE'],
        primaryExchange: 'HKSE',
    },
    'Asia/Singapore': {
        exchangeCodes: ['SES'],
        primaryExchange: 'SES',
    },
    'Asia/Shanghai': {
        exchangeCodes: ['SHH', 'SHZ'],
        primaryExchange: 'SHH',
    },
    'Asia/Seoul': {
        exchangeCodes: ['KSC', 'KOE'],
        primaryExchange: 'KSC',
    },
    'Asia/Tokyo': {
        exchangeCodes: ['JPX'],
        primaryExchange: 'JPX',
    },
};

export const getFinancialMarketHubHours = (timeZone: string, marketHours: readonly FmpExchangeMarketHour[]) => {
    const hub = FINANCIAL_MARKET_HUBS_BY_TIMEZONE[timeZone];

    if (!hub) {return [];}

    const hoursByExchange = new Map(marketHours.map((marketHour) => [marketHour.exchange, marketHour]));

    return hub.exchangeCodes
        .map((exchangeCode) => hoursByExchange.get(exchangeCode))
        .filter((marketHour): marketHour is FmpExchangeMarketHour => Boolean(marketHour));
};

export const getPrimaryFinancialMarketHour = (timeZone: string, marketHours: readonly FmpExchangeMarketHour[]) => {
    const hub = FINANCIAL_MARKET_HUBS_BY_TIMEZONE[timeZone];

    if (!hub) {return undefined;}

    return marketHours.find(({ exchange }) => exchange === hub.primaryExchange);
};
